export interface Settings {
    showTeamsOnDifferentPages: boolean;
}

export const DEFAULT_SETTINGS: Settings = {
    showTeamsOnDifferentPages: false
};